/**
 * LyteWork Medal Ribbons Data
 * Easy to update ribbon colors and pricing
 * 
 * Pricing Rules:
 * - Red/White/Blue: Free (included)
 * - Solid colors: +$0.50
 * - 2-color: +$0.75
 * - 3-color (except R/W/B): +$1.00
 */

window.MEDAL_RIBBONS = [
    // 3-Color Ribbons
    {
        id: 'red-white-blue',
        name: 'Red/White/Blue',
        type: 'three-color',
        colors: ['#bf0d3e', '#ffffff', '#002868'], // outer, middle, inner
        price: 0,
        default: true
    },
    {
        id: 'red-white-green',
        name: 'Red/White/Green',
        type: 'three-color',
        colors: ['#bf0d3e', '#ffffff', '#006847'],
        price: 1.00
    },
    
    // 2-Color Ribbons
    {
        id: 'red-white',
        name: 'Red/White',
        type: 'two-color',
        colors: ['#bf0d3e', '#ffffff'],
        price: 0.75
    },
    {
        id: 'red-yellow',
        name: 'Red/Yellow',
        type: 'two-color',
        colors: ['#bf0d3e', '#ffd700'],
        price: 0.75
    },
    {
        id: 'purple-white',
        name: 'Purple/White',
        type: 'two-color',
        colors: ['#663399', '#ffffff'],
        price: 0.75
    },
    {
        id: 'purple-gold',
        name: 'Purple/Gold',
        type: 'two-color',
        colors: ['#663399', '#d4af37'],
        price: 0.75
    },
    {
        id: 'navy-white',
        name: 'Navy/White',
        type: 'two-color',
        colors: ['#002868', '#ffffff'],
        price: 0.75
    },
    {
        id: 'navy-gold',
        name: 'Navy/Gold',
        type: 'two-color',
        colors: ['#002868', '#d4af37'],
        price: 0.75
    },
    {
        id: 'green-white',
        name: 'Green/White',
        type: 'two-color',
        colors: ['#006847', '#ffffff'],
        price: 0.75
    },
    {
        id: 'blue-white',
        name: 'Blue/White',
        type: 'two-color',
        colors: ['#0066cc', '#ffffff'],
        price: 0.75
    },
    {
        id: 'black-white',
        name: 'Black/White',
        type: 'two-color',
        colors: ['#1a1a1a', '#ffffff'],
        price: 0.75
    },
    {
        id: 'black-red',
        name: 'Black/Red',
        type: 'two-color',
        colors: ['#1a1a1a', '#bf0d3e'],
        price: 0.75
    },
    {
        id: 'black-orange',
        name: 'Black/Orange',
        type: 'two-color',
        colors: ['#1a1a1a', '#ff6600'],
        price: 0.75
    },
    
    // Solid Color Ribbons
    {
        id: 'yellow',
        name: 'Yellow',
        type: 'solid',
        colors: ['#ffd700'],
        price: 0.50
    },
    {
        id: 'white',
        name: 'White',
        type: 'solid',
        colors: ['#ffffff'],
        price: 0.50
    },
    {
        id: 'red',
        name: 'Red',
        type: 'solid',
        colors: ['#bf0d3e'],
        price: 0.50
    },
    {
        id: 'pink',
        name: 'Pink',
        type: 'solid',
        colors: ['#ff69b4'],
        price: 0.50
    },
    {
        id: 'purple',
        name: 'Purple',
        type: 'solid',
        colors: ['#663399'],
        price: 0.50
    },
    {
        id: 'orange',
        name: 'Orange',
        type: 'solid',
        colors: ['#ff6600'],
        price: 0.50
    },
    {
        id: 'navy',
        name: 'Navy Blue',
        type: 'solid',
        colors: ['#002868'],
        price: 0.50
    },
    {
        id: 'maroon',
        name: 'Maroon',
        type: 'solid',
        colors: ['#800000'],
        price: 0.50
    },
    {
        id: 'green',
        name: 'Green',
        type: 'solid',
        colors: ['#006847'],
        price: 0.50
    },
    {
        id: 'gold',
        name: 'Gold',
        type: 'solid',
        colors: ['#d4af37'],
        price: 0.50
    },
    {
        id: 'black',
        name: 'Black',
        type: 'solid',
        colors: ['#1a1a1a'],
        price: 0.50
    }
];

// Helper to get ribbon by ID
window.getRibbonById = function(id) {
    return window.MEDAL_RIBBONS.find(r => r.id === id);
};

// Helper to get default ribbon
window.getDefaultRibbon = function() {
    return window.MEDAL_RIBBONS.find(r => r.default) || window.MEDAL_RIBBONS[0];
};